<template>
  <el-container class="full">
    <el-aside width="210px" class="aside">
      <side-bar>
        <div
          slot="trademark"
          class="title-box">
          <div class="logo">
          </div>
        </div>
        <div slot="router">
          <component
            v-for="item in menuList"
            :key="item.name"
            :data="item"
            :is="item.children?'sub-menu':'menu-item'"/>
        </div>
      </side-bar>
    </el-aside>
    <div class="main">
      <Navbar/>
      <keep-alive :include="cachedViews">
        <router-view class="res"></router-view>
      </keep-alive>
    </div>
  </el-container>
</template>
<script>
import Navbar from './components/Navbar'
import SideBar from './components/Sidebar'
import SubMenu from './components/Sidebar/sub-menu'
import MenuItem from './components/Sidebar/menu-item'
export default {
  data() {
    return {
      menuList: [],
    }
  },
  components: {
    Navbar,
    SideBar,
    SubMenu,
    MenuItem
  },
  created() {
    this.menuList = JSON.parse(sessionStorage.getItem('menuList'))
    if (!this.menuList) {
      this.$router.push('/login')
    }
  },
  mounted() {
    let currentPath = ''
    this.$route.path === '/layout' ? currentPath = this.menuList[0].route : currentPath = this.$route.path
    this.$router.replace(this.menuList.length ? currentPath : '/login')
  },
  computed: {
    cachedViews() {
      return this.$store.state.global.tagList
    }
  }
}
</script>
<style lang="scss" scoped>
.main{
  width: 100%;
  height: 100%;
  padding: 0;
}
.res {
  position: relative;
  // height: calc(100vh - 73px) !important;
}
</style>
